import React from 'react';
import { MenuListItem, MenuSection } from '@atlassian/navigation-system';

export const RenderMostRecentProjectSection = ({
	projectItem,
}: {
	projectItem: React.JSX.Element | null;
}) => {
	return (
		!!projectItem && (
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section">
				<MenuSection>{projectItem}</MenuSection>
			</MenuListItem>
		)
	);
};
